import React from "react"
import {
  iconSizeCss,
  statusIconColorCss,
  type StatusIconProps,
} from "@myvp/shared/src/styles/icon-utils"
import { css } from "@emotion/react"

const Success = (
  props: Omit<StatusIconProps, "size"> & {
    size: StatusIconProps["size"] | "extra-large"
  }
) => {
  if (props.size === "small") {
    return (
      <svg
        className={props.className}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          iconSizeCss(props.size),
          statusIconColorCss("success", props.variant),
        ]}
      >
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="var(--shapeStrokeColor)"
          fill="var(--shapeFillColor)"
          strokeWidth="1.5"
        />
        <path d="M5 8L7 10L11 6" stroke="var(--textColor)" strokeWidth="1.5" />
      </svg>
    )
  }

  if (props.size === "large") {
    return (
      <svg
        className={props.className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          iconSizeCss(props.size),
          statusIconColorCss("success", props.variant),
        ]}
      >
        <circle
          cx="16"
          cy="16"
          r="13"
          stroke="var(--shapeStrokeColor)"
          fill="var(--shapeFillColor)"
          strokeWidth="2"
        />
        <path
          d="M9 16.5L13.6667 21L23 12"
          stroke="var(--textColor)"
          strokeWidth="2"
        />
      </svg>
    )
  }

  if (props.size === "extra-large") {
    return (
      <svg
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={[
          css`
            width: 54px;
            min-width: 54px;
            height: 54px;
            min-height: 54px;
          `,
          statusIconColorCss("success", props.variant),
        ]}
      >
        <circle
          cx="27.375"
          cy="27.375"
          r="22.5"
          stroke="var(--shapeStrokeColor)"
          fill="var(--shapeFillColor)"
          strokeWidth="3"
        />
        <path
          d="M15.1875 27.8438L23.0625 35.4375L38.8125 20.25"
          stroke="var(--textColor)"
          strokeWidth="3"
        />
      </svg>
    )
  }

  // Default to props.size === "medium"
  return (
    <svg
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[
        iconSizeCss(props.size),
        statusIconColorCss("success", props.variant),
      ]}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="var(--shapeFillColor)"
          stroke="var(--shapeStrokeColor)"
          strokeWidth="2"
        />
        <path
          d="M11.471 15.692L17.2219 9.69197L15.7781 8.30803L10.7012 13.6048L8.6728 11.7602L7.3272 13.2398L10.0762 15.7398L10.7969 16.3952L11.471 15.692Z"
          fill="var(--textColor)"
        />
      </svg>
    </svg>
  )
}

export default Success
